module.exports = "<ng-content *ngIf=\"selected\"></ng-content>\n"